<template>
  <div>
    <div class="card b-g-w">
      <div class="title">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-post"></use>
        </svg>
        <span>{{InfoData.custName}}</span>
      </div>
      <div class="list-wrap van-hairline--top">
        <div class="item" style="width:100%">
          <span class="key">所属行业：</span>
          <span class="value">{{InfoData.industryName}}</span>
        </div>
        <div class="item" style="width:100%">
          <span class="key">业务类型：</span>
          <span class="value">{{ InfoData.serviceTypeName }}</span>
        </div>
        <div class="item" style="width:100%">
          <span class="key">产品类型：</span>
          <span class="value">{{ InfoData.businessTypeName }}</span>
        </div>
        <div class="item">
          <span class="key">企业规模：</span>
          <span class="value">{{InfoData.scale}}</span>
        </div>
        <div class="item" v-if="InfoData.boStatus">
          <span class="key">商机状态：</span>
          <span class="value">{{boStatusFormat2(InfoData.boStatus)}}</span>
        </div>
        <div class="item" style="width:100%">
          <span class="key">客户等级：</span>
          <span class="value">{{custLevelFormat2(InfoData.custLevelId)}}</span>
        </div>
        <div class="item" style="width:100%">
          <span class="key">客户类型：</span>
          <span class="value">{{custTypeFormat2(InfoData.custType)}}</span>
        </div>
        <div class="item">
          <span class="key">线索来源：</span>
          <span class="value">{{custSourceFormat2(InfoData.custSource)}}</span>
        </div>
        <div class="item" style="width:100%">
          <span class="key">清洗结果：</span>
          <span class="value">{{washResultFormat2(InfoData.washResult)}}</span>
        </div>
        <div class="item" style="width:100%">
          <span class="key">地区：</span>
          <span class="value">{{InfoData.areaName}}</span>
        </div>
        <div class="item" style="width:100%">
          <span class="key">地址：</span>
          <span class="value">{{ InfoData.custAddress }}</span>
        </div>
        <div class="item" style="width:100%">
          <span class="key">创建时间：</span>
          <span class="value">{{InfoData.createTime}}</span>
        </div>
        <!-- <div class="item" v-if="InfoData.custStatus != 0" style="width:100%">
          <span class="key">最后跟进时间：</span>
          <span class="value">{{ InfoData.lastFollowTime }}</span>
        </div> -->
        <p style="border-bottom: 1px dashed #999;width: 100%;" v-if="InfoData.custStatus != 0"></p>
        <div class="item" v-if="InfoData.custStatus != 0">
          <span class="key">开始跟进时间：</span>
          <!-- parseTimes(InfoData.createTime, '{y}-{m}-{d}') -->
          <p class="value">{{ InfoData.createTime }}</p>
        </div>
        <div class="item" v-if="InfoData.custStatus != 0">
          <span class="key">到期释放时间：</span>
          <p class="value"><span style="color:#ff9800">{{ InfoData.lastReleaseTime }}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { parseTime } from "@/utils/util";
// import { selectAllCustLevel } from "@/api/scrm/custlevel"
export default {
  name: 'CardInfo',
  props: ['info'],
  watch: {
    info: {
      immediate: true, // 很重要！！！
      handler(val) {
        this.InfoData = !val ? {} : val
      }
    }
  },
  data() {
    return {
      InfoData: this.info,
      custLevelOptions: [],
      washResultOptions: [],
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      boStatusOptions: this.$store.state.dictOptions.custBoStatus || [],
      // 客户类型字典
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
    }
  },
  created() {
    console.log('cardinfo', this.info);
    //清洗结果
    this.getDicts("crm_cust_wash_result").then(response => {
      this.washResultOptions = response.data;
    });
    this.init()
  },
  methods: {
    init() {
      this.getCustLevelList();
    },
    // 获取客户等级名称———详情显示时
    custLevelFormat2(custLevelId) {
      if (this.custLevelOptions != null) {
        let obj = this.custLevelOptions.find(
          item => item.custLevelId === custLevelId
        );
        if (obj != null) {
          return obj.levelName;
        }
      }
    },
    //获取用户等级
    // getCustLevelList() {
    //   selectAllCustLevel(null).then(response => {
    //     this.custLevelOptions = response.data;
    //   });
    // },
    // 获取清洗结果
    washResultFormat2(washResult) {
      return this.selectDictLabel(this.washResultOptions, washResult);
    },
    // 客户来源
    custSourceFormat2(custSource) {
      return this.selectDictLabel(this.custSourceOptions, custSource);
    },
    // 商机状态
    boStatusFormat2(boStatus) {
      return this.selectDictLabel(this.boStatusOptions, boStatus);
    },
    custTypeFormat2(custType) {
      return this.selectDictLabel(this.custTypeOptions, custType);
    },
    parseTimes(time,type) {
      return parseTime(time, type);
    },
  },
}
</script>
<style lang="less">
.title {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  font-size: 36px;
  font-weight: bold;
  .icon {
    width: 40px;
    height: 40px;
  }

  span {
    margin-left: 5px;
  }
}
.list-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 20px;
  font-size: 28px;
  color: #999;
  .item {
    width: 48%;
    align-self: left;
    margin-bottom: 20px;
    .key{
      color: #333!important;
    }
    p{line-height: 0.5em;}
    .value{
      color: #666 !important;
    }
  }
}
</style>